// App.tsx
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/auth-context";
import { ThemeProvider } from "./context/ThemeContext";
import "leaflet/dist/leaflet.css";
import MainLayout from "./MainLayout";

const VERSION_CHECK_INTERVAL_MS = 15_000;

function useLogviVersionCheck() {
  useEffect(() => {
    let currentVersion: string | null = null;
    let stopped = false;

    async function checkVersion() {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, {
          cache: "no-store",
          headers: {
            Accept: "application/json",
          },
        });

        if (!res.ok) return;

        const data = await res.json();
        const latestVersion = String(data?.version || "").trim();

        if (!latestVersion) return;

        if (!currentVersion) {
          currentVersion = latestVersion;
          return;
        }

        if (latestVersion !== currentVersion && !stopped) {
          window.location.reload();
        }
      } catch {}
    }

    checkVersion();

    const interval = window.setInterval(
      checkVersion,
      VERSION_CHECK_INTERVAL_MS
    );

    return () => {
      stopped = true;
      window.clearInterval(interval);
    };
  }, []);
}

const App: React.FC = () => {
  useLogviVersionCheck();

  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <MainLayout>
            <AppRoutes />
          </MainLayout>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
